<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Store from '@/store/store'

export default {
  name: 'carts',
  store: Store,
  computed: {
    ...mapState([ 'carts' ]),
    ...mapGetters([ 'getCartId', 'getCartStatusLabel' ])
  },
  created () {
    this.aFetchCarts()
    this.aFetchCart()
  },
  methods: {
    ...mapActions([ 'aDeleteCart', 'aFetchCarts', 'aFetchCart', 'aFetchCartItems', 'aSwitchCart' ]),
    cartStatusClassName: function ({ row }) {
      if (this.isActive(row)) {
        return 'active ' + row.status
      }
      return row.status
    },
    handleCreate () {
      this.aSwitchCart()
        .then(() => {
          this.$router.push({ name: 'compounds' })
        })
    },
    handleEdit: function (cartId) {
      this.aSwitchCart(cartId)
        .then(() => {
          this.aFetchCart()
          .then(() => {
            this.aFetchCartItems()
            this.$router.push({ name: 'cart-items' })
          })
        })
    },
    handleDelete: function (cartId) {
      this.$confirm(
        'Ta operacja spowoduje bezpowrotne usunęcie koszyka. Czy na pewno chcesz kontunuować?',
        'Uwaga',
        {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          type: 'warning'
        }).then(() => {
          this.aDeleteCart(cartId)
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Koszyk usunięty.'
              })
              this.aFetchCarts()
            })
        }).catch(() => { })
    },
    isActive: function (row) {
      if (row.cartId === this.getCartId) {
        return true
      }
      return false
    }
  }
}
</script>

<template>
  <el-main>
    <header :gutter="20">
      <el-col :span="16">
        <h1>Historia zamówień</h1>
      </el-col>
      <el-col :span="8" align="right">
        <el-button
          plain
          icon="el-icon-circle-plus-outline"
          type="primary"
          @click="handleCreate"
        >Rozpocznij nowe zamówienie</el-button>
      </el-col>
    </header>
    <el-table
      :data="carts"
      :row-class-name="cartStatusClassName"
      style="width: 100%"
    >
      <el-table-column
        label="id"
        width=70
      >
        <template slot-scope="scope">
          {{ scope.row.cartId.slice(0,4) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Date"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.created | format_datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Nazwa">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        width="200"
      >
        <template slot-scope="scope">
          {{ getCartStatusLabel(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Ilość pozycji"
        align="right"
        width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.itemCount | format_item_amount }}
        </template>
      </el-table-column>
      <el-table-column
        label="Wartość"
        align="right"
        width="200"
      >
        <template slot-scope="scope">
          {{ scope.row.price | format_price }}
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        label="Operacje"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            type="primary"
            @click="handleEdit(scope.row.cartId)"
          >
            <i
              class="el-icon-folder-opened"
              v-if="isActive(scope.row)"
            ></i>
            <i
              class="el-icon-folder"
              v-if="!isActive(scope.row)"
            ></i>
          </el-button>
          <el-button
            size="mini"
            icon="el-icon-delete"
            plain
            type="danger"
            :disabled="['opened'].includes(scope.row.status) ? false : true"
            @click="handleDelete(scope.row.cartId)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<style lang="sass" scoped>
  header
    & .el-button
      margin-top: 2rem
</style>



// WEBPACK FOOTER //
// src/components/history.vue